/*
 * @Author: Risker-C
 * @Date: 2021-09-13 17:20:52
 * @LastEditTime: 2021-09-18 17:28:49
 * @LastEditors: Risker-C
 * @Description: 
 * @FilePath: \yh-wms\src\views\business\view\DataBox.tsx
 */
import { Button, Modal, Select } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { globalPrompt } from "@/components/message";
import useNavModel from "@/model/navModel";
import { useBusinessModel } from "../businessModel";
import React, { useState } from "react";
export const DataBox = () => {
    const {
        selectedRowKeys,
        dataSource,
        selectedRow,
        setAddFormVal,
        setSelectedRow,
        setSelectedRowKeys,
        categoryOption,
        onRemove,
        resetEditCatch
    } = useBusinessModel();
    const { selectedNavId, replaceNav, addNav, findNav, selectNav, switchNavState } = useNavModel();
    const [modelVisible, setModelVisible] = useState(false)
    const [category, setCategory] = useState("")

    const onAdd = () => {
        setModelVisible(true)
    }
    const handleCancel = () => {
        setModelVisible(false)
    }

    const handleChange = (value: string) => {
        setCategory(value)
    }

    const handleOk = () => {
        const item = dataSource.find(item => item.columnCode === category)
        if (item) {
            setSelectedRow([item])
            setSelectedRowKeys([item.id as string])
            handleCancel()
            onEdit()
        } else {
            setAddFormVal({
                columnCode: category,
            })
            addNav('5-1', { id: "", mode: "add" })
        }
    }

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑", type: "warning" });
            return;
        }
        let appointmentEditKey = "5-2";
        let isFindNav = findNav(appointmentEditKey);
        if (!isFindNav) {
            addNav(appointmentEditKey, { id: selectedRowKeys[0] as string, mode: "edit" });
        } else {
            globalPrompt("modal", {
                title: "国内案例跳转详情",
                type: "warning",
                text: "您还有国内案例详情未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(appointmentEditKey, { id: selectedRowKeys[0] as string, mode: "edit" });
                    resetEditCatch()
                }
            })
        }
    }
    const onDelete = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑", type: "warning" });
            return;
        }
        onRemove({ id: selectedRowKeys })
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onAdd}
        >新增</Button>

        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onEdit}
        >编辑</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onDelete}
        >删除</Button>
    </>

    return (
        <>
            <YhBox title=" " action={action}>
                <DataTable />
            </YhBox>
            <Modal
                visible={modelVisible}
                title="请选择业务范围"
                onOk={handleOk}
                onCancel={handleCancel}
            >
                <Select
                    options={categoryOption}
                    onChange={handleChange}>
                </Select>
            </Modal>
        </>
    )
}
